var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_content"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"chat-page-wrapper"},[_c('database-query',{attrs:{"databaseTable":_vm.databaseTable,"title":_vm.title,"suggestions":_vm.suggestions}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }